export default __webpack_public_path__ + "static/media/info.7b39b710.svg";